import Tasks from 'APP/Tasks';
import Entities from 'STORE';

export const checkAuthorizationAccounts = async (): Promise<void> => {
  try {
    const accounts = await Tasks.calendar.getAuthorizationAccounts();

    if (!accounts || !Entities.calendar.isActiveAccount) {
      Entities.calendar.setLoading(false);
    }

    await Tasks.calendar.checkIsCompact();
  } catch {
    Entities.calendar.setLoading(false);
    return;
  }
};
